// removed by extract-text-webpack-plugin
module.exports = {"xsmall":"only screen and (min-width: 375px)","small":"only screen and (min-width: 481px)","medium":"only screen and (min-width: 768px)","large":"only screen and (min-width: 993px)","xlarge":"only screen and (min-width: 1201px)","retina":"(-webkit-min-device-pixel-ratio: 2)","yourGoalsWrapper":"yourGoalsWrapper-1GOGe","yourGoals":"yourGoals-1d3dm","run":"run-2if3j","trainingPlans":"trainingPlans-3PHBP","runner":"runner-2b2bc","goals":"goals-3Yd-Z"};


//////////////////
// WEBPACK FOOTER
// ./src/components/app-page/your-goals/_yourGoals.css
// module id = 1181
// module chunks = 1